const newrelic = window.newrelic;

export const initNewRelic = () => {
  newrelic?.setCustomAttribute('env', process.env.ENVIRONMENT as string);
};
